import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum RoundingMethodId {
  MATH = 'math',
  UP = 'up',
  DOWN = 'down',
  HALF = 'half',
}

export class RoundingMethod extends Codebook<RoundingMethodId> {
  private constructor(
    public readonly id: RoundingMethodId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  static readonly MATH = new RoundingMethod(RoundingMethodId.MATH, () => $t('Mathematically'))

  static readonly UP = new RoundingMethod(RoundingMethodId.UP, () => $t('Up'))

  static readonly DOWN = new RoundingMethod(RoundingMethodId.DOWN, () => $t('Down'))

  static readonly HALF = new RoundingMethod(RoundingMethodId.HALF, () =>
    $t('Closest multiple of 5'),
  )
}
